import { Bars3Icon, XMarkIcon } from "@heroicons/vue/24/outline";
import { nextTick } from "vue";
import { mapMutations } from "vuex";
export default {
  name: "PageHeader",
  components: {
    Bars3Icon,
    XMarkIcon
  },
  data: () => ({
    isMobileMenuOpen: false,
    svgcn: `
    <svg t="1742187328755" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3727" width="30" height="30"><path d="M533.333333 580.266667H145.066667c-29.866667 0-55.466667-25.6-55.466667-55.466667V136.533333c0-29.866667 25.6-51.2 55.466667-51.2h388.266666c29.866667 0 51.2 25.6 51.2 55.466667v388.266667c0 25.6-21.333333 51.2-51.2 51.2zM145.066667 106.666667c-17.066667 0-34.133333 12.8-34.133334 29.866666v388.266667c0 17.066667 12.8 34.133333 34.133334 34.133333h388.266666c17.066667 0 29.866667-12.8 29.866667-34.133333V136.533333c0-17.066667-12.8-34.133333-29.866667-34.133333l-388.266666 4.266667zM712.533333 614.4H810.666667v89.6h-98.133334z" fill="#ffffff" p-id="3728"></path><path d="M887.466667 456.533333h-388.266667c-25.6 0-42.666667 17.066667-42.666667 42.666667v388.266667c0 25.6 17.066667 42.666667 42.666667 42.666666h388.266667c25.6 0 42.666667-21.333333 42.666666-42.666666v-388.266667c0-25.6-17.066667-42.666667-42.666666-42.666667z m-51.2 294.4H810.666667v-21.333333h-98.133334v115.2h-25.6v-115.2h-98.133333v21.333333h-25.6v-162.133333h123.733333v-59.733333h25.6v59.733333h123.733334v162.133333z" fill="#ffffff" p-id="3729"></path><path d="M588.8 614.4h98.133333v89.6h-98.133333z" fill="#ffffff" p-id="3730"></path><path d="M209.066667 465.066667l106.666666-273.066667h38.4l110.933334 273.066667h-42.666667l-34.133333-85.333334H277.333333l-29.866666 85.333334h-38.4z m81.066666-115.2H384l-29.866667-72.533334c-8.533333-21.333333-17.066667-42.666667-21.333333-55.466666-4.266667 12.8-8.533333 29.866667-12.8 51.2l-29.866667 76.8z" fill="#ffffff" p-id="3731"></path></svg>
    `,
    svgen: `
   <svg t="1742187276031" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3327" width="30" height="30"><path d="M533.333333 580.266667H145.066667c-29.866667 0-55.466667-25.6-55.466667-55.466667V136.533333c0-29.866667 25.6-51.2 55.466667-51.2h388.266666c29.866667 0 51.2 25.6 51.2 55.466667v388.266667c0 25.6-21.333333 51.2-51.2 51.2zM145.066667 106.666667c-17.066667 0-34.133333 12.8-34.133334 29.866666v388.266667c0 17.066667 12.8 34.133333 34.133334 34.133333h388.266666c17.066667 0 29.866667-12.8 29.866667-34.133333V136.533333c0-17.066667-12.8-34.133333-29.866667-34.133333l-388.266666 4.266667z" fill="#ffffff" p-id="3328"></path><path d="M324.266667 187.733333h25.6v59.733334h123.733333v162.133333h-25.6v-21.333333H349.866667v115.2h-25.6V388.266667H226.133333v21.333333h-21.333333V247.466667h123.733333V187.733333h-4.266666zM226.133333 362.666667h98.133334V273.066667H226.133333v89.6z m123.733334 0h98.133333V273.066667H349.866667v89.6zM682.666667 571.733333l-12.8 51.2-29.866667 81.066667h93.866667l-29.866667-76.8c-8.533333-21.333333-17.066667-42.666667-21.333333-55.466667z" fill="#ffffff" p-id="3329"></path><path d="M887.466667 456.533333h-388.266667c-25.6 0-42.666667 17.066667-42.666667 42.666667v388.266667c0 25.6 17.066667 42.666667 42.666667 42.666666h388.266667c25.6 0 42.666667-21.333333 42.666666-42.666666v-388.266667c0-25.6-17.066667-42.666667-42.666666-42.666667z m-115.2 362.666667l-34.133334-85.333333h-115.2l-29.866666 85.333333h-34.133334l106.666667-273.066667h38.4l110.933333 273.066667h-42.666666z" fill="#ffffff" p-id="3330"></path></svg>
   `,
    textareaRectBottom: 100
  }),
  computed: {
    isEnglish() {
      return this.$i18n.locale.startsWith('en');
    },
    dynamicSVG() {
      return this.$i18n.locale.startsWith('en') ? this.svgcn : this.svgen;
    },
    showTopBtn() {
      const userAgent = navigator.userAgent.toLowerCase();
      const isUserAgentMobile = /iphone|ipod|android|blackberry|windows phone|mobile|opera mini/.test(userAgent);
      const isScreenSmall = window.innerWidth <= 640; // 设定屏幕宽度阈值  
      // const isTextareaHidden = document.getElementById('instruction-input').getClientRects().bottom-80 < 0
      const isTextareaHidden = this.textareaRectBottom - 80 < 0;
      return isUserAgentMobile && isScreenSmall && isTextareaHidden;
    }
  },
  methods: {
    ...mapMutations("SettingModule", ["updateTemplate", "updateInstruction"]),
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    updateScrollForTopBtn() {
      this.textareaRectBottom = document.getElementById('instruction-input').getBoundingClientRect().bottom;
    },
    toTop() {
      document.getElementById('instruction-input').scrollIntoView({
        behavior: 'smooth'
      });
    },
    toggleLanguage() {
      // this.$i18n.locale = this.isEnglish ? "zh" : "en";
      const locale = this.isEnglish ? "zh" : "en";
      localStorage.setItem("lang", locale);
      window.location.reload();
      // if (this.$i18n.locale === "zh") {
      //   this.updateTemplate({template:'cjc2025'})
      // }else{
      //   this.updateTemplate({template:'aaai2025'})
      // }
      // this.updateInstruction({instruction:""})

      // const el = document.getElementById('instruction-input')
      // nextTick(()=>{
      //   el.parentElement.style.height = "auto"
      //   el.style.height = "auto"; // 先重置高度
      //   el.parentElement.style.height = Math.min(330, el.scrollHeight) + "px"; // 设为内容高度
      //   el.style.height = Math.min(330, el.scrollHeight) + "px"; // 设为内容高度
      //   if (el.scrollHeight>330){
      //     el.style.overflowY = 'auto'
      //   }
      // })
    }
  },
  mounted() {
    document.getElementsByTagName('main')[0].addEventListener('scroll', this.updateScrollForTopBtn);
  },
  beforeUnmount() {
    document.getElementsByTagName('main')[0].removeEventListener('scroll', this.updateScrollForTopBtn);
  }
};